<script setup lang="ts">
const platform = useState('platform')
const route = useRoute()

const data = computed(() => ({
  ...platform.value,
  website: `https://${platform.value.domain}`,
}))
</script>

<template>
  <ContentPage :path="route.path" :data="data" />
</template>